"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMarketPricedExchangeElectricity = function IconMarketPricedExchangeElectricity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M35 6.33v-2H14l-.207.005C10.983 4.465 9 7.237 9 10.33v17.665l-4.85 7.807-.05.091-.074.17a2.41 2.41 0 0 0 1.784 3.249l.19.018h36v-2H6.127l-.01-.003a.4.4 0 0 1-.215-.198l-.028-.07a.4.4 0 0 1-.001-.221l.016-.045 4.636-7.463H45v-17h-2v15H11v-17l.004-.216C11.09 8.037 12.398 6.33 14 6.33zm5 6.51-1.268-1.268-8.802 8.802-6.631-6.63-8.711 8.723-1.415-1.414L23.3 10.915l6.63 6.63 7.388-7.387L36.05 8.89l5.4-1.44zm0 18.49v1H12v-1zm-5 4v-1H11v1z",
    clipRule: "evenodd"
  })));
};

export { IconMarketPricedExchangeElectricity, IconMarketPricedExchangeElectricity as default };
